var map = {
	"./af": "../../../../ng2-bootstrap/node_modules/moment/locale/af.js",
	"./af.js": "../../../../ng2-bootstrap/node_modules/moment/locale/af.js",
	"./ar": "../../../../ng2-bootstrap/node_modules/moment/locale/ar.js",
	"./ar-ly": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ar-tn.js",
	"./ar.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ar.js",
	"./az": "../../../../ng2-bootstrap/node_modules/moment/locale/az.js",
	"./az.js": "../../../../ng2-bootstrap/node_modules/moment/locale/az.js",
	"./be": "../../../../ng2-bootstrap/node_modules/moment/locale/be.js",
	"./be.js": "../../../../ng2-bootstrap/node_modules/moment/locale/be.js",
	"./bg": "../../../../ng2-bootstrap/node_modules/moment/locale/bg.js",
	"./bg.js": "../../../../ng2-bootstrap/node_modules/moment/locale/bg.js",
	"./bn": "../../../../ng2-bootstrap/node_modules/moment/locale/bn.js",
	"./bn.js": "../../../../ng2-bootstrap/node_modules/moment/locale/bn.js",
	"./bo": "../../../../ng2-bootstrap/node_modules/moment/locale/bo.js",
	"./bo.js": "../../../../ng2-bootstrap/node_modules/moment/locale/bo.js",
	"./br": "../../../../ng2-bootstrap/node_modules/moment/locale/br.js",
	"./br.js": "../../../../ng2-bootstrap/node_modules/moment/locale/br.js",
	"./bs": "../../../../ng2-bootstrap/node_modules/moment/locale/bs.js",
	"./bs.js": "../../../../ng2-bootstrap/node_modules/moment/locale/bs.js",
	"./ca": "../../../../ng2-bootstrap/node_modules/moment/locale/ca.js",
	"./ca.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ca.js",
	"./cs": "../../../../ng2-bootstrap/node_modules/moment/locale/cs.js",
	"./cs.js": "../../../../ng2-bootstrap/node_modules/moment/locale/cs.js",
	"./cv": "../../../../ng2-bootstrap/node_modules/moment/locale/cv.js",
	"./cv.js": "../../../../ng2-bootstrap/node_modules/moment/locale/cv.js",
	"./cy": "../../../../ng2-bootstrap/node_modules/moment/locale/cy.js",
	"./cy.js": "../../../../ng2-bootstrap/node_modules/moment/locale/cy.js",
	"./da": "../../../../ng2-bootstrap/node_modules/moment/locale/da.js",
	"./da.js": "../../../../ng2-bootstrap/node_modules/moment/locale/da.js",
	"./de": "../../../../ng2-bootstrap/node_modules/moment/locale/de.js",
	"./de-at": "../../../../ng2-bootstrap/node_modules/moment/locale/de-at.js",
	"./de-at.js": "../../../../ng2-bootstrap/node_modules/moment/locale/de-at.js",
	"./de.js": "../../../../ng2-bootstrap/node_modules/moment/locale/de.js",
	"./dv": "../../../../ng2-bootstrap/node_modules/moment/locale/dv.js",
	"./dv.js": "../../../../ng2-bootstrap/node_modules/moment/locale/dv.js",
	"./el": "../../../../ng2-bootstrap/node_modules/moment/locale/el.js",
	"./el.js": "../../../../ng2-bootstrap/node_modules/moment/locale/el.js",
	"./en-au": "../../../../ng2-bootstrap/node_modules/moment/locale/en-au.js",
	"./en-au.js": "../../../../ng2-bootstrap/node_modules/moment/locale/en-au.js",
	"./en-ca": "../../../../ng2-bootstrap/node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "../../../../ng2-bootstrap/node_modules/moment/locale/en-ca.js",
	"./en-gb": "../../../../ng2-bootstrap/node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "../../../../ng2-bootstrap/node_modules/moment/locale/en-gb.js",
	"./en-ie": "../../../../ng2-bootstrap/node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "../../../../ng2-bootstrap/node_modules/moment/locale/en-ie.js",
	"./en-nz": "../../../../ng2-bootstrap/node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "../../../../ng2-bootstrap/node_modules/moment/locale/en-nz.js",
	"./eo": "../../../../ng2-bootstrap/node_modules/moment/locale/eo.js",
	"./eo.js": "../../../../ng2-bootstrap/node_modules/moment/locale/eo.js",
	"./es": "../../../../ng2-bootstrap/node_modules/moment/locale/es.js",
	"./es-do": "../../../../ng2-bootstrap/node_modules/moment/locale/es-do.js",
	"./es-do.js": "../../../../ng2-bootstrap/node_modules/moment/locale/es-do.js",
	"./es.js": "../../../../ng2-bootstrap/node_modules/moment/locale/es.js",
	"./et": "../../../../ng2-bootstrap/node_modules/moment/locale/et.js",
	"./et.js": "../../../../ng2-bootstrap/node_modules/moment/locale/et.js",
	"./eu": "../../../../ng2-bootstrap/node_modules/moment/locale/eu.js",
	"./eu.js": "../../../../ng2-bootstrap/node_modules/moment/locale/eu.js",
	"./fa": "../../../../ng2-bootstrap/node_modules/moment/locale/fa.js",
	"./fa.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fa.js",
	"./fi": "../../../../ng2-bootstrap/node_modules/moment/locale/fi.js",
	"./fi.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fi.js",
	"./fo": "../../../../ng2-bootstrap/node_modules/moment/locale/fo.js",
	"./fo.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fo.js",
	"./fr": "../../../../ng2-bootstrap/node_modules/moment/locale/fr.js",
	"./fr-ca": "../../../../ng2-bootstrap/node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "../../../../ng2-bootstrap/node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fr-ch.js",
	"./fr.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fr.js",
	"./fy": "../../../../ng2-bootstrap/node_modules/moment/locale/fy.js",
	"./fy.js": "../../../../ng2-bootstrap/node_modules/moment/locale/fy.js",
	"./gd": "../../../../ng2-bootstrap/node_modules/moment/locale/gd.js",
	"./gd.js": "../../../../ng2-bootstrap/node_modules/moment/locale/gd.js",
	"./gl": "../../../../ng2-bootstrap/node_modules/moment/locale/gl.js",
	"./gl.js": "../../../../ng2-bootstrap/node_modules/moment/locale/gl.js",
	"./he": "../../../../ng2-bootstrap/node_modules/moment/locale/he.js",
	"./he.js": "../../../../ng2-bootstrap/node_modules/moment/locale/he.js",
	"./hi": "../../../../ng2-bootstrap/node_modules/moment/locale/hi.js",
	"./hi.js": "../../../../ng2-bootstrap/node_modules/moment/locale/hi.js",
	"./hr": "../../../../ng2-bootstrap/node_modules/moment/locale/hr.js",
	"./hr.js": "../../../../ng2-bootstrap/node_modules/moment/locale/hr.js",
	"./hu": "../../../../ng2-bootstrap/node_modules/moment/locale/hu.js",
	"./hu.js": "../../../../ng2-bootstrap/node_modules/moment/locale/hu.js",
	"./hy-am": "../../../../ng2-bootstrap/node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "../../../../ng2-bootstrap/node_modules/moment/locale/hy-am.js",
	"./id": "../../../../ng2-bootstrap/node_modules/moment/locale/id.js",
	"./id.js": "../../../../ng2-bootstrap/node_modules/moment/locale/id.js",
	"./is": "../../../../ng2-bootstrap/node_modules/moment/locale/is.js",
	"./is.js": "../../../../ng2-bootstrap/node_modules/moment/locale/is.js",
	"./it": "../../../../ng2-bootstrap/node_modules/moment/locale/it.js",
	"./it.js": "../../../../ng2-bootstrap/node_modules/moment/locale/it.js",
	"./ja": "../../../../ng2-bootstrap/node_modules/moment/locale/ja.js",
	"./ja.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ja.js",
	"./jv": "../../../../ng2-bootstrap/node_modules/moment/locale/jv.js",
	"./jv.js": "../../../../ng2-bootstrap/node_modules/moment/locale/jv.js",
	"./ka": "../../../../ng2-bootstrap/node_modules/moment/locale/ka.js",
	"./ka.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ka.js",
	"./kk": "../../../../ng2-bootstrap/node_modules/moment/locale/kk.js",
	"./kk.js": "../../../../ng2-bootstrap/node_modules/moment/locale/kk.js",
	"./km": "../../../../ng2-bootstrap/node_modules/moment/locale/km.js",
	"./km.js": "../../../../ng2-bootstrap/node_modules/moment/locale/km.js",
	"./ko": "../../../../ng2-bootstrap/node_modules/moment/locale/ko.js",
	"./ko.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ko.js",
	"./ky": "../../../../ng2-bootstrap/node_modules/moment/locale/ky.js",
	"./ky.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ky.js",
	"./lb": "../../../../ng2-bootstrap/node_modules/moment/locale/lb.js",
	"./lb.js": "../../../../ng2-bootstrap/node_modules/moment/locale/lb.js",
	"./lo": "../../../../ng2-bootstrap/node_modules/moment/locale/lo.js",
	"./lo.js": "../../../../ng2-bootstrap/node_modules/moment/locale/lo.js",
	"./lt": "../../../../ng2-bootstrap/node_modules/moment/locale/lt.js",
	"./lt.js": "../../../../ng2-bootstrap/node_modules/moment/locale/lt.js",
	"./lv": "../../../../ng2-bootstrap/node_modules/moment/locale/lv.js",
	"./lv.js": "../../../../ng2-bootstrap/node_modules/moment/locale/lv.js",
	"./me": "../../../../ng2-bootstrap/node_modules/moment/locale/me.js",
	"./me.js": "../../../../ng2-bootstrap/node_modules/moment/locale/me.js",
	"./mi": "../../../../ng2-bootstrap/node_modules/moment/locale/mi.js",
	"./mi.js": "../../../../ng2-bootstrap/node_modules/moment/locale/mi.js",
	"./mk": "../../../../ng2-bootstrap/node_modules/moment/locale/mk.js",
	"./mk.js": "../../../../ng2-bootstrap/node_modules/moment/locale/mk.js",
	"./ml": "../../../../ng2-bootstrap/node_modules/moment/locale/ml.js",
	"./ml.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ml.js",
	"./mr": "../../../../ng2-bootstrap/node_modules/moment/locale/mr.js",
	"./mr.js": "../../../../ng2-bootstrap/node_modules/moment/locale/mr.js",
	"./ms": "../../../../ng2-bootstrap/node_modules/moment/locale/ms.js",
	"./ms-my": "../../../../ng2-bootstrap/node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ms-my.js",
	"./ms.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ms.js",
	"./my": "../../../../ng2-bootstrap/node_modules/moment/locale/my.js",
	"./my.js": "../../../../ng2-bootstrap/node_modules/moment/locale/my.js",
	"./nb": "../../../../ng2-bootstrap/node_modules/moment/locale/nb.js",
	"./nb.js": "../../../../ng2-bootstrap/node_modules/moment/locale/nb.js",
	"./ne": "../../../../ng2-bootstrap/node_modules/moment/locale/ne.js",
	"./ne.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ne.js",
	"./nl": "../../../../ng2-bootstrap/node_modules/moment/locale/nl.js",
	"./nl.js": "../../../../ng2-bootstrap/node_modules/moment/locale/nl.js",
	"./nn": "../../../../ng2-bootstrap/node_modules/moment/locale/nn.js",
	"./nn.js": "../../../../ng2-bootstrap/node_modules/moment/locale/nn.js",
	"./pa-in": "../../../../ng2-bootstrap/node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "../../../../ng2-bootstrap/node_modules/moment/locale/pa-in.js",
	"./pl": "../../../../ng2-bootstrap/node_modules/moment/locale/pl.js",
	"./pl.js": "../../../../ng2-bootstrap/node_modules/moment/locale/pl.js",
	"./pt": "../../../../ng2-bootstrap/node_modules/moment/locale/pt.js",
	"./pt-br": "../../../../ng2-bootstrap/node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "../../../../ng2-bootstrap/node_modules/moment/locale/pt-br.js",
	"./pt.js": "../../../../ng2-bootstrap/node_modules/moment/locale/pt.js",
	"./ro": "../../../../ng2-bootstrap/node_modules/moment/locale/ro.js",
	"./ro.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ro.js",
	"./ru": "../../../../ng2-bootstrap/node_modules/moment/locale/ru.js",
	"./ru.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ru.js",
	"./se": "../../../../ng2-bootstrap/node_modules/moment/locale/se.js",
	"./se.js": "../../../../ng2-bootstrap/node_modules/moment/locale/se.js",
	"./si": "../../../../ng2-bootstrap/node_modules/moment/locale/si.js",
	"./si.js": "../../../../ng2-bootstrap/node_modules/moment/locale/si.js",
	"./sk": "../../../../ng2-bootstrap/node_modules/moment/locale/sk.js",
	"./sk.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sk.js",
	"./sl": "../../../../ng2-bootstrap/node_modules/moment/locale/sl.js",
	"./sl.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sl.js",
	"./sq": "../../../../ng2-bootstrap/node_modules/moment/locale/sq.js",
	"./sq.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sq.js",
	"./sr": "../../../../ng2-bootstrap/node_modules/moment/locale/sr.js",
	"./sr-cyrl": "../../../../ng2-bootstrap/node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sr.js",
	"./ss": "../../../../ng2-bootstrap/node_modules/moment/locale/ss.js",
	"./ss.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ss.js",
	"./sv": "../../../../ng2-bootstrap/node_modules/moment/locale/sv.js",
	"./sv.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sv.js",
	"./sw": "../../../../ng2-bootstrap/node_modules/moment/locale/sw.js",
	"./sw.js": "../../../../ng2-bootstrap/node_modules/moment/locale/sw.js",
	"./ta": "../../../../ng2-bootstrap/node_modules/moment/locale/ta.js",
	"./ta.js": "../../../../ng2-bootstrap/node_modules/moment/locale/ta.js",
	"./te": "../../../../ng2-bootstrap/node_modules/moment/locale/te.js",
	"./te.js": "../../../../ng2-bootstrap/node_modules/moment/locale/te.js",
	"./th": "../../../../ng2-bootstrap/node_modules/moment/locale/th.js",
	"./th.js": "../../../../ng2-bootstrap/node_modules/moment/locale/th.js",
	"./tl-ph": "../../../../ng2-bootstrap/node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "../../../../ng2-bootstrap/node_modules/moment/locale/tl-ph.js",
	"./tlh": "../../../../ng2-bootstrap/node_modules/moment/locale/tlh.js",
	"./tlh.js": "../../../../ng2-bootstrap/node_modules/moment/locale/tlh.js",
	"./tr": "../../../../ng2-bootstrap/node_modules/moment/locale/tr.js",
	"./tr.js": "../../../../ng2-bootstrap/node_modules/moment/locale/tr.js",
	"./tzl": "../../../../ng2-bootstrap/node_modules/moment/locale/tzl.js",
	"./tzl.js": "../../../../ng2-bootstrap/node_modules/moment/locale/tzl.js",
	"./tzm": "../../../../ng2-bootstrap/node_modules/moment/locale/tzm.js",
	"./tzm-latn": "../../../../ng2-bootstrap/node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "../../../../ng2-bootstrap/node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "../../../../ng2-bootstrap/node_modules/moment/locale/tzm.js",
	"./uk": "../../../../ng2-bootstrap/node_modules/moment/locale/uk.js",
	"./uk.js": "../../../../ng2-bootstrap/node_modules/moment/locale/uk.js",
	"./uz": "../../../../ng2-bootstrap/node_modules/moment/locale/uz.js",
	"./uz.js": "../../../../ng2-bootstrap/node_modules/moment/locale/uz.js",
	"./vi": "../../../../ng2-bootstrap/node_modules/moment/locale/vi.js",
	"./vi.js": "../../../../ng2-bootstrap/node_modules/moment/locale/vi.js",
	"./x-pseudo": "../../../../ng2-bootstrap/node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "../../../../ng2-bootstrap/node_modules/moment/locale/x-pseudo.js",
	"./zh-cn": "../../../../ng2-bootstrap/node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "../../../../ng2-bootstrap/node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "../../../../ng2-bootstrap/node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "../../../../ng2-bootstrap/node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "../../../../ng2-bootstrap/node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "../../../../ng2-bootstrap/node_modules/moment/locale/zh-tw.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../../../ng2-bootstrap/node_modules/moment/locale recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/ng2-bootstrap/~/moment/locale ^\.\/.*$
// module id = ../../../../ng2-bootstrap/node_modules/moment/locale recursive ^\.\/.*$
// module chunks = 0